import React, { useContext, useState } from 'react';
import { FaUser } from 'react-icons/fa';
import { AuthContext } from '@CONTEXTS';
import { Button, Select } from 'antd';
import { useMerchantList } from '@HOOKS';
import './index.scss';
import { doLogout } from '@AUTH';

const UserProfile = ({ setChangingMerchant }) => {
  const { logOut, info: user } = useContext(AuthContext);
  const merchantList = useMerchantList();
  const [selectedMerchant, setSelectedMerchant] = useState(
    sessionStorage.getItem('merchantId') === 'null' ||
      sessionStorage.getItem('merchantId') === null
      ? null
      : Number(sessionStorage.getItem('merchantId'))
  );
  const handleSelectMerchant = async (input) => {
    setChangingMerchant(true);
    setSelectedMerchant(input);
    await sessionStorage.setItem('merchantId', input);
    setChangingMerchant(false);
  };

  const handleLogout = async () => {
    const response = await doLogout();
    logOut();
  };

  return (
    <div className="header-user-info">
      <div className="user">
        <>
          <span>
            {user.companyName && user.name
              ? `${user.companyName}-${user.name}`
              : user.companyName}
          </span>
          <FaUser />
        </>

        {merchantList?.length > 1 && (
          <>
            <Select
              defaultValue={null}
              style={{
                width: 200,
              }}
              bordered={false}
              options={merchantList}
              value={selectedMerchant}
              onChange={(e) => handleSelectMerchant(e)}
            />
          </>
        )}
      </div>
      <div className="logout">
        <Button
          type="link"
          onClick={() => {
            handleLogout();
          }}
          size="small"
        >
          Çıkış Yap
        </Button>
      </div>
    </div>
  );
};

export default UserProfile;
